import React, { MouseEventHandler, MouseEvent } from 'react';
import { GamePlayer, GameVersus} from '../../utils';
import Button from '../Button';
import Logo from '../Logo';
import PlayerSelect from '../PlayerSelect';

import styles from './styles.module.css';

interface StartupProps {
  selectedPlayer: GamePlayer;
  onPlayerSelected: (player: GamePlayer) => void;
  onStartGame: (versus: GameVersus) => void;
}

const Startup = (props: StartupProps) => {

  const onButtonStartClicked: MouseEventHandler = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    props.onStartGame(event.currentTarget.getAttribute('data-versus') as GameVersus)
  }

  return (
    <div className={styles['player-pick']}>
      <Logo/>
      <PlayerSelect selectedPlayer={props.selectedPlayer} onPlayerSelected={props.onPlayerSelected}/>
      <Button data-versus={'cpu'} color='yellow' onClick={onButtonStartClicked}>New Game (vs CPU)</Button>
      <Button data-versus={'player'} color='blue' onClick={onButtonStartClicked}>New Game (vs Player)</Button>
    </div>
  );
}

export default Startup;